export class ErrorRadionuclide extends Error {
  rnName: string;

  constructor(message: string, rnName: string) {
    super(message);
    this.rnName = rnName;
  }
}
